const areaList = [
    { cn: '中国          ', code: '+86  ' },
    { cn: '日本          ', code: '+81  ' },
    { cn: '韩国          ', code: '+82  ' },
    { cn: '印度          ', code: '+91  ' },
    { cn: '巴基斯坦      ', code: '+92  ' },
    { cn: '孟加拉国      ', code: '+880 ' },
    { cn: '斯里兰卡      ', code: '+94  ' },
    { cn: '尼泊尔        ', code: '+977 ' },
    { cn: '马来西亚      ', code: '+60  ' },
    { cn: '新加坡        ', code: '+65  ' },
    { cn: '泰国          ', code: '+66  ' },
    { cn: '菲律宾        ', code: '+63  ' },
    { cn: '越南          ', code: '+84  ' },
    { cn: '柬埔寨        ', code: '+855 ' },
    { cn: '老挝          ', code: '+856 ' },
    { cn: '缅甸          ', code: '+95  ' },
    { cn: '印度尼西亚    ', code: '+62  ' },
    { cn: '文莱          ', code: '+673 ' },
    { cn: '东帝汶        ', code: '+670 ' },
    { cn: '英国          ', code: '+44  ' },
    { cn: '德国          ', code: '+49  ' },
    { cn: '法国          ', code: '+33  ' },
    { cn: '意大利        ', code: '+39  ' },
    { cn: '西班牙        ', code: '+34  ' },
    { cn: '荷兰          ', code: '+31  ' },
    { cn: '比利时        ', code: '+32  ' },
    { cn: '瑞士          ', code: '+41  ' },
    { cn: '奥地利        ', code: '+43  ' },
    { cn: '瑞典          ', code: '+46  ' },
    { cn: '挪威          ', code: '+47  ' },
    { cn: '丹麦          ', code: '+45  ' },
    { cn: '芬兰          ', code: '+358 ' },
    { cn: '希腊          ', code: '+30  ' },
    { cn: '葡萄牙        ', code: '+351 ' },
    { cn: '波兰          ', code: '+48  ' },
    { cn: '匈牙利        ', code: '+36  ' },
    { cn: '捷克共和国    ', code: '+420 ' },
    { cn: '斯洛伐克      ', code: '+421 ' },
    { cn: '爱尔兰        ', code: '+353 ' },
    { cn: '乌克兰        ', code: '+380 ' },
    { cn: '俄罗斯        ', code: '+7   ' },
    { cn: '土耳其        ', code: '+90  ' },
    { cn: '美国          ', code: '+1   ' },
    { cn: '加拿大        ', code: '+1   ' },
    { cn: '墨西哥        ', code: '+52  ' },
    { cn: '古巴          ', code: '+53  ' },
    { cn: '多米尼加共和国', code: '+1-809' },
    { cn: '波多黎各      ', code: '+1-787' },
    { cn: '牙买加        ', code: '+1-876' },
    { cn: '巴哈马        ', code: '+1-242' },
    { cn: '特立尼达和多巴哥', code: '+1-868' },
    { cn: '洪都拉斯      ', code: '+504 ' },
    { cn: '危地马拉      ', code: '+502 ' },
    { cn: '尼加拉瓜      ', code: '+505 ' },
    { cn: '哥斯达黎加    ', code: '+506 ' },
    { cn: '巴拿马        ', code: '+507 ' },
    { cn: '巴西          ', code: '+55  ' },
    { cn: '阿根廷        ', code: '+54  ' },
    { cn: '智利          ', code: '+56  ' },
    { cn: '哥伦比亚      ', code: '+57  ' },
    { cn: '委内瑞拉      ', code: '+58  ' },
    { cn: '乌拉圭        ', code: '+598 ' },
    { cn: '巴拉圭        ', code: '+595 ' },
    { cn: '玻利维亚      ', code: '+591 ' },
    { cn: '厄瓜多尔      ', code: '+593 ' },
    { cn: '秘鲁          ', code: '+51  ' },
    { cn: '南非          ', code: '+27  ' },
    { cn: '尼日利亚      ', code: '+234 ' },
    { cn: '埃及          ', code: '+20  ' },
    { cn: '肯尼亚        ', code: '+254 ' },
    { cn: '坦桑尼亚      ', code: '+255 ' },
    { cn: '乌干达        ', code: '+256 ' },
    { cn: '埃塞俄比亚    ', code: '+251 ' },
    { cn: '加纳          ', code: '+233 ' },
    { cn: '科特迪瓦      ', code: '+225 ' },
    { cn: '摩洛哥        ', code: '+212 ' },
    { cn: '阿尔及利亚    ', code: '+213 ' },
    { cn: '苏丹          ', code: '+249 ' },
    { cn: '安哥拉        ', code: '+244 ' },
    { cn: '赞比亚        ', code: '+260 ' },
    { cn: '津巴布韦      ', code: '+263 ' },
    { cn: '沙特阿拉伯    ', code: '+966 ' },
    { cn: '阿联酋        ', code: '+971 ' },
    { cn: '以色列        ', code: '+972 ' },
    { cn: '伊朗          ', code: '+98  ' },
    { cn: '伊拉克        ', code: '+964 ' },
    { cn: '约旦          ', code: '+962 ' },
    { cn: '叙利亚        ', code: '+963 ' },
    { cn: '黎巴嫩        ', code: '+961 ' },
    { cn: '卡塔尔        ', code: '+974 ' },
    { cn: '科威特        ', code: '+965 ' },
    { cn: '巴林          ', code: '+973 ' },
    { cn: '阿曼          ', code: '+968 ' },
    { cn: '也门          ', code: '+967 ' },
    { cn: '澳大利亚      ', code: '+61  ' },
    { cn: '新西兰        ', code: '+64  ' },
    { cn: '斐济          ', code: '+679 ' },
    { cn: '巴布亚新几内亚', code: '+675 ' },
    { cn: '萨摩亚        ', code: '+685 ' },
    { cn: '汤加          ', code: '+676 ' },
    { cn: '瓦努阿图      ', code: '+678 ' },
    { cn: '基里巴斯      ', code: '+686 ' },
    { cn: '所罗门群岛    ', code: '+677 ' }]
export default areaList






// WEBPACK FOOTER //
// ./src/view/area.js